import React from "react";
import ReactTooltip from "react-tooltip";
import ApplyFilterIcon from "@assets/images/applyFilterIcon.svg";
const numFormat = (num) => {
  if (!isNaN(num)) {
    if (!!num && num > 1000000000000) {
      return (num / 1000000000000).toFixed(2) + "T";
    } else if (!!num && num > 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (!!num && num > 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (!!num && num > 1000) {
      return (num / 1000).toFixed(2) + "K";
    } else return num.toFixed(2);
  } else return num;
};
export default class TopShipmentSection extends React.Component {
  state = {
    topSectionData: this.props.data ? this.props.data : [],
  };
  viewShipmentClick = (value, type) => {
    if (this.props.handleViewShipment) this.props.handleViewShipment(value, type);
  };
  redirectingUser(data1) {
    let tempanalyticsViewAllKey = !!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "";
    let tempfilter_value1 = !!data1 && data1.length !== 0 ? data1 : "";
    let tempfilter_value2 = "";
    this.props.mapClickedFilterKey(tempanalyticsViewAllKey, tempfilter_value1, tempfilter_value2);
  }
  render() {
    const suppress = !!this.props.suppressChartFilterInteractions;
    return (
      <>
        {!!this && !!this.state && !!this.state.topSectionData && this.state.topSectionData.length !== 0 ? (
          <div className="table-responsive">
            <table className="table" cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <td scope="row">{this.props.headerLabel}</td>
                  <td scope="row">{this.props.mainLabel ? this.props.mainLabel : "Shipments"}</td>
                  {!suppress ? <td></td> : null}
                </tr>
              </thead>
              <tbody>
                {this.state.topSectionData.map((item, index) => (
                  <tr key={index}>
                    <td scope="row" className="col-md-8">
                      <span className="d-block">{item.key ? this.props.analyticsFieldKeys === "notify_party_name" || this.props.analyticsFieldKeys === "derived_secondary_notify_parties" ? <span className="text-capitalize">{item.key.toLowerCase()}</span> : item.key : item.description}</span>
                    </td>
                    <td className="col-md-3">
                      <span className="d-block">
                        {item.value !== undefined && item.value !== "" ? numFormat(item.value) : numFormat(item.count)}
                        {!!this.props.mainLabel && this.props.mainLabel !== "TEUs" && this.props.mainLabel !== "USD" && this.props.mainLabel !== "Weight (kg)" && this.props.mainLabel !== "Shipments" ? "%" : <></>}
                      </span>
                    </td>
                    {!suppress ? (
                      <td className="col-md-1">
                        <a data-tip data-for={this.props.from + this.props.headerLabel + index}>
                          <span className="d-block" role="button" onClick={this.redirectingUser.bind(this, !!item.key && item.key !== "" && (this.props.analyticsFieldKeys === "notify_party_name" || this.props.analyticsFieldKeys === "derived_secondary_notify_parties" || this.props.analyticsFieldKeys === "sections" || this.props.analyticsFieldKeys === "derived_sections" || this.props.analyticsFieldKeys === "section" || this.props.analyticsFieldKeys === "six_digit_hs_code") ? item.key : !!item.hsCodes && item.hsCodes.length > 0 ? item.hsCodes : item.allHsCode)}>
                            <img src={ApplyFilterIcon} alt="..." className="img-fluid" />
                          </span>
                        </a>
                      </td>
                    ) : null}
                    <td>
                      {item.marketShare ? (
                        suppress ? (
                          <span className="tw-text-xs tw-text-gray-500">Share {item.marketShare.toFixed(2)}%</span>
                        ) : (
                          <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={this.props.from + this.props.headerLabel + index}>
                            Market Share {item.marketShare.toFixed(2)}% <br />
                            <hr />
                            Click to Apply Filter
                          </ReactTooltip>
                        )
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}
